import { BankAccountDetails, BankAccountUsage } from '@commerce-payment-webcomponents/sdk';
import { DragEvent, ChangeEvent } from 'react';

/* eslint-disable @typescript-eslint/naming-convention */
export interface BankAccountContainerPropsType {
  customClassName?: string;
  addBankAccountClick: () => void;
  onBankUpdateMenuClick: (bankId: string, accountUsage: BankAccountUsage) => void;
}

export interface BankAccountHeaderPropsType {
  onAddBankClick: () => void;
}

export interface AddAccountFormPropsType {
  onCloseDrawer: () => void;
}

export interface RefundBankListPropsType {
  accountUsage: string | null;
  onRefundListDrawerClose: () => void;
}

export interface AddedBanksMenuPropsType {
  isMenuOpen?: boolean;
  onBankUpdateMenuClick: (bankId: string, accountUsage: BankAccountUsage) => void;
  bankDetails: BankAccountDetails;
}

export interface AddedBanksListingPropsType {
  onBankUpdateMenuClick: (bankId: string, accountUsage: BankAccountUsage) => void;
  addBankAccountClick?: () => void;
}

export type CustomEventPropType = { files: Record<number, File> } & (
  | DragEvent<Element>
  | ChangeEvent<HTMLInputElement>
);

export interface BankTncCMSResponseType {
  _version: number;
  locale: string;
  uid: string;
  ACL: {};
  _in_progress: boolean;
  created_at: string;
  created_by: string;
  t_c_title?: string;
  t_c_description?: string;
  tags: string[];
  title: string;
  updated_at: string;
  updated_by: string;
  publish_details: {
    environment: string;
    locale: string;
    time: string;
    user: string;
  };
}

export enum AccountStatusColorEnum {
  CANCELLED = 'CANCELLED',
  DOCUMENTNOTUPLOADED = 'DOCUMENTNOTUPLOADED',
  DOCUMENTUPLOADED = 'DOCUMENTUPLOADED',
  EXPIRED = 'EXPIRED',
  NEW = 'NEW',
  INVALID = 'INVALID',
  NOTVALD = 'NOTVALD',
  NOTVALIDATED = 'NOTVALIDATED',
  REJECTED = 'REJECTED',
  VALID = 'VALID',
  PENDINGVERIFICATION = 'PENDINGVERIFICATION',
  REJECTEDINVALIDACCTYPE = 'REJECTEDINVALIDACCTYPE',
  REJECTEDNODETAIL = 'REJECTEDNODETAIL',
  REJECTEDNOSIGNATURE = 'REJECTEDNOSIGNATURE',
  APPROVED = 'APPROVED',
  RJTINVDTYP = 'RJTINVDTYP',
  RJCTNODTIL = 'RJCTNODTIL',
  RJCTNOSIGN = 'RJCTNOSIGN',
}
